















































































// project
import { setFavIcon } from "@/utils/dom";
import * as AssetAPI from "@/services/api/assets";
import { Asset } from "@/psychlab/types";
// local
import * as TypeEditors from "../ts/TypeEditors";
import FallbackEditor from "./fallback-editor.vue";

const confirmLeave = () => {
	return window.confirm("You have unsaved changes. Are you sure?");
}


export default {
	data(){
		return {
			asset:null as Asset|null,
			notFound:false,
			modified:false,
			resetting:false,
			data:null as any,
			latestData:null as any,
			submitting:false,
			latestVersion:null as any,
			isLoading:false
		}
	},
	computed:{
		editorComponent(){
			const scope = this as any;
			return scope.asset ? (TypeEditors as any)[scope.asset.type] : null;
		}
	},
	watch:{
		modified(){
			this.refreshPageTitle();
		},
		asset:{
			deep:true,
			handler(v){
				if(!v){ return; }
				this.refreshPageTitle();
			}
		},
		data:{
			deep:true,
			handler(v, o){
				if(!o){  return; } 
				if(this.resetting){
					this.resetting = false;
					return;
				}
				this.dataModified(v);	
			}
		}
	},
	methods:{
		async loadAsset(){
			this.isLoading = true;
			let { assetId } = this.$route.params;
			try{
				let asset = await AssetAPI.getAsset(assetId);
				this.latestVersion = await AssetAPI.getAssetVersion(assetId, "latest", "data base");
				const { data:latestData } = this.latestVersion;
				this.asset = asset;
				this.latestData = latestData;
				this.data = JSON.parse(JSON.stringify(this.latestData));
			}
			catch(err){
				this.notFound = true;
				console.error(err.message);
			}
			finally{
				if(!this.asset){
					this.$router.push({name:"Home"});
				}
			}
			this.isLoading = false;
		},
		dataModified(newValue:any){
			var ns = JSON.stringify(newValue);
			if(ns === JSON.stringify(this.latestData)){
				return;
			}
			if(ns === JSON.stringify(this.data)){
				// return;
			}
			this.modified = true;
		},
		modifiedWithin(data:any){
			this.modified = true;
			this.data = JSON.parse(JSON.stringify(data));
		},
		resetChanges(){
			this.resetting = true;
			this.data = JSON.parse(JSON.stringify(this.latestData));
			this.modified = false;

			(document.activeElement as any).blur();
			(document.body as any).focus();
		},
		async submitVersion(closeTab:boolean = false){
			this.submitting = true;
			try{
				let { _id } = await AssetAPI.saveAssetVersion(this.$route.params.assetId, { data:this.data, base:this.latestVersion._id });
				this.latestVersion = await AssetAPI.getAssetVersion(this.$route.params.assetId, _id, "data base");
				this.modified = false;
				this.resetting = false;
				this.latestData = JSON.parse(JSON.stringify(this.data));
				if(closeTab){
					window.close();
				}
			}
			catch(err){
				console.error(err);
			}
			this.submitting = false;
		},
		async publish(){
			return this.submitVersion(false);
		},
		refreshPageTitle(){
			if(!this.asset){ return; }
			document.title = `${this.modified ? '* ' : '' }${this.asset.name} | Edit`;
		},
		onPageUnload(){
			return this.modified ? "There are unsaved changes." : null;
		}
	},
	created(){
		this.loadAsset();
		window.onbeforeunload = this.onPageUnload;
	},
	destroyed(){
		window.onbeforeunload = null;
		//TODO:REMOVE IN VUE3
	},
	beforeRouteUpdate(to:any, from:any, next:any){

		let samePage = to.name === from.name;

		// check params
		Object.keys(to.params)
		.forEach(k => {
			samePage = samePage && (to.params[k] === from.params[k]);
		});

		if(samePage) { return next(); }

		if(!this.modified){ return next(); }
		
		if (confirmLeave()) {
			next()
		} else {
			next(false)
		}

	},
	beforeRouteLeave (to:any, from:any, next:any) {

		if(!this.modified) { return next(); }
		if (confirmLeave()) {
			next()
		} else {
			next(false)
		}
	}
	// unmounted(){
	// 	window.onbeforeunload = null;
	// }


};
